import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=3c3a5a10&"
import script from "./VideoPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=3c3a5a10&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c3a5a10')) {
      api.createRecord('3c3a5a10', component.options)
    } else {
      api.reload('3c3a5a10', component.options)
    }
    module.hot.accept("./VideoPlayer.vue?vue&type=template&id=3c3a5a10&", function () {
      api.rerender('3c3a5a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/VideoPlayer.vue"
export default component.exports